// opervex-frontend/src/components/CustomAlert/index.js
import { Component } from "react";
import { Alert, Container } from "react-bootstrap";
import AlertService from "../../services/AlertService";

class CustomAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      variant: "danger",
    };
    this.timeoutId = null;
  }

  componentDidMount() {
    AlertService.register((alertData) => {
      this.setState(alertData, () => {
        this.startAutoCloseIfNeeded();
      });
    });
  }

  componentWillUnmount() {
    // Limpa timeout se sair da tela
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  startAutoCloseIfNeeded() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId); // Limpa timeout anterior se existir
    }

    const { variant } = this.state;
    if (variant === "success" || variant === "warning") {
      this.timeoutId = setTimeout(() => {
        this.setState({ messages: [] });
      }, 5000); // 5 segundos
    }
  }

  handleClose = () => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.setState({ messages: [] });
  };

  render() {
    const { messages, variant } = this.state;

    if (!messages || messages.length === 0) return null;

    return (
      <Container className="mt-2">
        <Alert variant={variant} className="mt-3" onClose={this.handleClose} dismissible>
          {messages.map((message, index) => (
            <div key={index} dangerouslySetInnerHTML={{ __html: message?.message || message }} />
          ))}
        </Alert>
      </Container>
    );
  }
}

export default CustomAlert;
